import React, { useEffect } from 'react';
import type { SingleCommonType } from '../../types';
import { commonBackInfo } from '../../utils';
import { brandAffinityPlaceholder } from '../../constants/placeholder';
import { useCompareRangeDefaultValue } from '../../hooks/init';
import { useIntl } from 'umi';
// import './index.scss';
import CustomThanRange from '../../components/CustomThanRange';
import { FILTER_CONST } from '../../constants';
import BubbleCommon, {
  influencerBrandAffinityTipsText,
} from '@op/components/BubbleCommon';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

const errorText = 'The input data cannot exceed 100%';
export default function BrandAffinitySelect({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  lang,
  oriDefaultFilter,
  backOriDefaultValue,
}: SingleCommonType) {
  const { compareRef, rangeValue, setRangeValue, diffClassName } =
    useCompareRangeDefaultValue({
      defaultValue,
      filterValue,
      defaultKey: 'brand_affinitys',
      valueKey: 'affinity',
      oriDefaultFilter,
      backOriDefaultValue,
      dealwithValueFunc: (value: string) => {
        const v = Number(value);
        return isNaN(v) ? '0' : String(v * 100);
      },
    });

  const { formatMessage } = useIntl();
  useEffect(() => {
    const showHeader = compareRef.current?.buttonElement?.({
      ...rangeValue,
      lSign: rangeValue.sign,
    });
    const data = [];
    const { start, end, sign } = rangeValue;
    const value: any = {
      end_affinity: Number(end) / 100,
      sign,
    };

    if (!sign) {
      value.start_affinity = Number(start) / 100;
    }

    data.push(value);

    onChange?.(
      'brandAffinitys',
      commonBackInfo({ brand_affinitys: data }, { brandAffinitys: showHeader }),
    );
  }, [rangeValue, formatMessage]);

  function verifyValueFunc({
    start,
    end,
    sign,
  }: {
    start: string;
    end: string;
    sign: string;
  }) {
    const endFlag = Number(end) > 100;
    const startFlag = Number(start) > 100;

    const errorTipsText = endFlag ? errorText : '';
    if (sign === FILTER_CONST.THAN_RANGE_CUSTOMIZE) {
      return {
        startErrorText: '',
        endErrorText: errorTipsText,
        flag: endFlag,
      };
    }

    return {
      startErrorText: startFlag ? errorText : '',
      endErrorText: errorTipsText,
      flag: startFlag || endFlag,
    };
  }

  return (
    <BubbleCommon
      placement="top"
      tipsMap={influencerBrandAffinityTipsText}
      showIcon={false}
    >
      <div className={`dbo-affinity-select ${diffClassName}`}>
        <CustomThanRange
          lang={lang}
          ref={compareRef}
          setRangeValue={setRangeValue}
          rangeValue={rangeValue}
          placeholder={brandAffinityPlaceholder}
          unit="%"
          verifyFunc={verifyValueFunc}
          pointKey={FilterButtonPoint.brandAffinitys}
        ></CustomThanRange>
      </div>
    </BubbleCommon>
  );
}
